<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_1246_5169)">
                            <path
                                d="M12.2853 8.07778C11.8102 6.22465 10.1473 4.84668 8.1518 4.84668C6.15632 4.84668 4.49342 6.22465 4.01831 8.07778C3.92329 8.45791 4.20836 8.83804 4.63596 8.83804H11.7152C12.0953 8.83804 12.3803 8.45791 12.2853 8.07778Z"
                                fill="#265D91" />
                            <path
                                d="M8.15109 3.89633C9.22693 3.89633 10.0991 3.02411 10.0991 1.94816C10.0991 0.872223 9.22693 0 8.15109 0C7.07526 0 6.20312 0.872223 6.20312 1.94816C6.20312 3.02411 7.07526 3.89633 8.15109 3.89633Z"
                                fill="#265D91" />
                            <path
                                d="M26.8244 8.07778C26.3492 6.22465 24.6863 4.84668 22.6909 4.84668C20.6954 4.84668 18.985 6.22465 18.5574 8.07778C18.4623 8.45791 18.7474 8.83804 19.175 8.83804H26.2542C26.5868 8.83804 26.9194 8.45791 26.8244 8.07778Z"
                                fill="#265D91" />
                            <path
                                d="M22.6902 3.89633C23.766 3.89633 24.6381 3.02411 24.6381 1.94816C24.6381 0.872223 23.766 0 22.6902 0C21.6143 0 20.7422 0.872223 20.7422 1.94816C20.7422 3.02411 21.6143 3.89633 22.6902 3.89633Z"
                                fill="#265D91" />
                            <path
                                d="M15.421 17.2484C12.6179 17.2484 10.2898 19.1491 9.67216 21.7625C9.52962 22.2851 9.95723 22.8078 10.5274 22.8078H20.3622C20.9324 22.8078 21.3125 22.2851 21.2174 21.7625C20.5523 19.1491 18.2242 17.2484 15.421 17.2484Z"
                                fill="#265D91" />
                            <path
                                d="M15.421 15.9179C16.9167 15.9179 18.1292 14.7053 18.1292 13.2095C18.1292 11.7137 16.9167 10.5011 15.421 10.5011C13.9254 10.5011 12.7129 11.7137 12.7129 13.2095C12.7129 14.7053 13.9254 15.9179 15.421 15.9179Z"
                                fill="#265D91" />
                            <path
                                d="M10.2427 18.2937C10.3853 17.9136 10.1952 17.5335 9.81511 17.3909C8.62733 16.9633 7.6771 16.108 7.10696 14.9676C6.53682 13.8272 6.48931 12.5443 6.8694 11.3564C7.01194 10.9763 6.82189 10.5961 6.4418 10.4536C6.06171 10.311 5.68162 10.5011 5.53908 10.8812C4.44632 14.1123 6.15673 17.581 9.34 18.7214C9.43502 18.7689 9.95765 18.959 10.2427 18.2937Z"
                                fill="#265D91" />
                            <path
                                d="M24.401 10.4536C24.0209 10.5961 23.8309 10.9763 23.9734 11.3564C24.401 12.5443 24.306 13.8272 23.7358 14.9676C23.1657 16.108 22.2155 16.9633 21.0277 17.3909C20.6476 17.5335 20.41 17.9136 20.6001 18.2938C20.8852 18.959 21.4078 18.7689 21.5028 18.7214C24.7336 17.6285 26.3965 14.1123 25.3037 10.8812C25.1612 10.5486 24.7811 10.311 24.401 10.4536Z"
                                fill="#265D91" />
                            <path
                                d="M11.858 4.13396C12.8083 3.18364 14.0436 2.66096 15.4214 2.66096C16.7517 2.66096 18.0345 3.18364 18.9847 4.13396C19.1273 4.27651 19.6024 4.51409 19.9825 4.13396C20.2675 3.84886 20.2675 3.42122 19.9825 3.13612C18.7472 1.9007 17.1318 1.23547 15.4214 1.23547C13.711 1.23547 12.0956 1.9007 10.8603 3.13612C10.5752 3.42122 10.5752 3.84886 10.8603 4.13396C11.1454 4.41906 11.573 4.41906 11.858 4.13396Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_1246_5169" x="0" y="0" width="30.8418" height="30.8079"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1246_5169" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1246_5169"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>

                    Utilisateurs
                </h1>

                <!--begin::Menu-->

            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a href="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Utilisateurs</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Permissions</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->

            <div class="card-body tools">
                <div class="title mb-15">
                    <h4>Liste des Permissions </h4>
                </div>
                <div class="container">
                    <div class="row mb-3">
                        <div class="col-lg-3">
                            <form class="w-100 position-relative" autocomplete="off">
                                <!--begin::Icon-->
                                <i class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                                <!--end::Icon-->
                                <!--begin::Input-->
                                <input type="text" class="form-control form-control-solid searching px-13" name="search" value="" placeholder="Rechercher " />
                                <!--end::Input-->
                            </form>
                        </div>
                        <div class="col-lg-3 ">

                        </div>
                        <div class="col-lg-3 ">

                        </div>
                        <div class="col-lg-3">


                        </div>

                    </div>

                    <div class="table-responsive mt-15">
                        <table class="table align-middle fs-6 gy-5 style-table" id="list_cra">
                            <thead>
                                <th class="min-w-125px">
                                    LISTE DES permissions
                                </th>
                                <th class="min-w-125px">
                                    Action
                                </th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><span>Contacter profil</span></td>
                                    <td>
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1"
                                                id="flexCheckDefault" />
                                        </div>
                                    </td>

                                </tr>
                                <tr>
                                    <td><span>Chat</span></td>
                                    <td>
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1"
                                                id="flexCheckDefault" />
                                        </div>
                                    </td>

                                </tr>

                                <tr>
                                    <td><span>Cra</span></td>
                                    <td>
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1"
                                                id="flexCheckDefault" />
                                        </div>
                                    </td>

                                </tr>
                                <tr>
                                    <td><span>Appel d’offre</span></td>
                                    <td>
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1"
                                                id="flexCheckDefault" />
                                        </div>
                                    </td>

                                </tr>
                                <tr>
                                    <td><span>Offre d’emploi</span></td>
                                    <td>
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1"
                                                id="flexCheckDefault" />
                                        </div>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>


                </div>


            </div>
        </div>

    </div>
    <!--end::Content container-->
</div>